module.exports = __webpack_public_path__ + "static/media/sj.5b6dddaf.svg";